<div>
    <br />
    <button mat-button class="button-narrow" (click)="appService.toggleHelpPane()" matTooltip="Sharing">
        <mat-icon class="material-symbols-outlined">
            share
        </mat-icon>
    </button>
</div>
